import { columnFormats } from "../../constants/constants";
import { EMPTY_CELL_PLACEHOLDER } from "./constants";

/**
 * Converts DOM cell text for export: trims whitespace and maps "--" to null.
 */
export function exportCellValue(text) {
  const trimmed = String(text ?? "").trim();
  return trimmed === EMPTY_CELL_PLACEHOLDER ? null : trimmed;
}

/**
 * Strips trailing zeros from decimal strings (e.g. "1.23000" → "1.23").
 */
export function trimTrailingDecimalZeros(value) {
  const str = String(value ?? "").trim();
  if (!/^-?\d+\.\d+$/.test(str)) return str;
  return str.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
}

/**
 * Returns the InsightOut format group (date, number, etc.) for an Excel numFmt string.
 */
export function getFormatGroup(format) {
  return columnFormats.find((col) =>
    col.options?.some((o) => o.xlsx === format)
  )?.group;
}

/** True when the Excel numFmt belongs to a number column format. */
export function isNumberFormat(format) {
  return getFormatGroup(format) === "number";
}

/** True when the Excel numFmt belongs to a date/time column format. */
export function isDateFormat(format) {
  return getFormatGroup(format) === "date";
}

/**
 * Maps a raw attribute value and Excel numFmt to the typed value stored on the cell.
 */
export function normalizeCellValue(value, format) {
  const group = getFormatGroup(format);

  if (group === "date") {
    return new Date(value);
  }

  if (format === "@") {
    return trimTrailingDecimalZeros(value);
  }

  const num = parseFloat(value);
  return isNaN(num) ? null : num;
}

/** True for null/undefined cells and the "--" empty placeholder. */
export function isEmptyExportValue(value) {
  return value == null || value === EMPTY_CELL_PLACEHOLDER;
}
